import { Component, Input } from '@angular/core';

@Component({
  selector: 'default-cell',
  standalone: true,
  template: ` <span class="cell-text">{{ data }}</span> `,
  styles: [
    `
      .cell-text {
        font-family: var(--manrope);
        font-weight: 500;
        font-size: 16px;
        color: var(--text-secondary);
      }
    `,
  ],
})
export class DefaultCellComponent {
  @Input() data: any;
}
